import PropTypes from "prop-types";

import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

// Mirrors NoteItem's card — leading icon, heading and byline, then a few body
// lines — so the list does not reflow when the notes arrive.
export function NoteItemSkeleton() {
  return (
    <Card size="sm" className="tw:w-full" aria-hidden="true">
      <CardContent>
        <div className="tw:flex tw:gap-3">
          <Skeleton className="tw:mt-0.5 tw:size-6 tw:shrink-0" />
          <div className="tw:min-w-0 tw:flex-1">
            <Skeleton className="tw:h-4 tw:w-16" />
            <Skeleton className="tw:mt-1 tw:h-3.5 tw:w-48" />
            <div className="tw:mt-3 tw:flex tw:flex-col tw:gap-2">
              <Skeleton className="tw:h-3.5 tw:w-full" />
              <Skeleton className="tw:h-3.5 tw:w-11/12" />
              <Skeleton className="tw:h-3.5 tw:w-2/3" />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export function NotesSkeleton({ rows = 3 }) {
  return (
    <div
      aria-busy="true"
      aria-label="Loading notes"
      className="tw:flex tw:flex-col tw:gap-3"
    >
      {Array.from({ length: rows }, (_, index) => (
        <NoteItemSkeleton key={index} />
      ))}
    </div>
  );
}

NotesSkeleton.propTypes = {
  rows: PropTypes.number,
};
